import { AfterViewInit, Component, OnInit } from '@angular/core';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2'
import { Router } from '@angular/router';
import { LocalServiceService } from '../../shareModule/services/local-service.service';

declare let Winwheel: any;

@Component({
  selector: 'app-lucky-draw',
  templateUrl: './lucky-draw.component.html',
  styleUrls: ['./lucky-draw.component.scss']
})
// export class LuckyDrawComponent implements OnInit {

//   constructor() { }

//   ngOnInit(): void {
//   }

// }

export class LuckyDrawComponent implements OnInit {
  title = 'angular10-winwheelJS';
  theWheel: any;
  innerWheel: any;
  outerWheel: any;
  wheelPower = 0;
  wheelSpinning = false;
  winningSegment: string;
  buttonImage = '../assets/images/spin_off.png';
  hideShowCheckMark = 0;
  hideShowLoader = 0;
  lucky_draws: any;
  winId: any;
  entered_phone_number: any;
  saved_lucky_draw: any;
  chancesLeft: any;
  rewardList: any = 0;
  // get_lucky_draw_options_response: any;
  // innerSegment: { fillStyle: string; text: string; textFontSize: number; }[];
  // outerSegment: { fillStyle: string; text: string; }[];

  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private router: Router,
    private local: LocalServiceService
  ) {

  }

  // ngOnInit(): void {
  //   this.get_lucky_draw_options();
  // }

  get_lucky_draw_options() {
    this.auth.get_lucky_draw_options().subscribe((response: any) => {
      // this.get_lucky_draw_options_response = response.body;

      let innerSegment = [];

      let outerSegment = [];

      for (let i in response.body) {
        innerSegment.push({
          'fillStyle': response.body[i].innerBackColor, 'text': response.body[i].innerName, 'textFontSize': response.body[i].innerFontSize, id: response.body[i].id
        });

        outerSegment.push({
          'fillStyle': response.body[i].outerBackColor, 'text': response.body[i].outerName, id: response.body[i].id
        });
      }

      document.body.className = "lucky_draw_back";

      // Need to create the SECONDARY wheel first because on construct the variable which keeps track of the wheel to animate will
      // be set to the last created wheel, and we want the outer one the primary with the animation etc.
      this.innerWheel = new Winwheel({
        'numSegments': 6,
        'textFillStyle': '#ffffff',
        // 'responsive': true,
        // 'textFontSize': 18,
        // 'lineWidth': 0,
        'strokeStyle': '#cccccc',
        'textLineWidth': 10,
        'outerRadius': 180,        // Set the outer radius to make the wheel smaller than the outer wheel.
        'segments': innerSegment
      });

      // Define the outer wheel, we will treat this as the PRIMARY which means it clears the canvas when drawing and also
      // gets the animaton applied to it. We must callback a function during the animation to move and draw the inner wheel
      // so the 2 wheels appear as one thing on the canvas.
      this.outerWheel = new Winwheel({
        'numSegments': 6,
        'textMargin': 0,
        // 'responsive': true,
        // 'lineWidth': 0,
        'strokeStyle': '#cccccc',
        'textOrientation': 'curved',
        'textAligment': 'outer',
        'outerRadius': 210,
        'innerRadius': 180,    // Set inner radius to the size of the inner wheel since the inner part of the wheel
        'segments': outerSegment,
        'animation':
        {
          'type': 'spinToStop',                     // Define animation more or less as normal, except for the callbackAfter().
          'duration': 5,
          'spins': 5,
          'easing': 'Power3.easeOut',
          'callbackAfter': this.drawInnerWheel.bind(this),     // Call back after each frame of the animation a function we can draw the inner wheel from.
          'callbackFinished': this.alertPrize.bind(this)
        }
      });

      this.outerWheel.draw();
      this.innerWheel.draw(false);
    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message);
      } else if (e.status == 401) {
        this.local.logout();
        this.router.navigate(['/']);
      }
    })
  }

  //-------------------------OLD DESIGN------------------------------------------


  // powerSelected(powerLevel): void {
  //   if (this.wheelSpinning === false) {
  //     document.getElementById('pw1').className = '';
  //     document.getElementById('pw2').className = '';
  //     document.getElementById('pw3').className = '';
  //     if (powerLevel >= 1) {
  //       document.getElementById('pw1').className = 'pw1';
  //     }
  //     if (powerLevel >= 2) {
  //       document.getElementById('pw2').className = 'pw2';
  //     }
  //     if (powerLevel >= 3) {
  //       document.getElementById('pw3').className = 'pw3';
  //     }
  //     this.wheelPower = powerLevel;
  //     this.buttonImage = '../assets/images/spin_on.png';
  //     document.getElementById('spin_button').className = 'clickable';
  //   }
  // }

  // startSpin(): void {
  //   if (this.wheelSpinning === false) {
  //     if (this.wheelPower === 1) {
  //       this.theWheel.animation.spins = 3;
  //     } else if (this.wheelPower === 2) {
  //       this.theWheel.animation.spins = 8;
  //     } else if (this.wheelPower === 3) {
  //       this.theWheel.animation.spins = 15;
  //     }
  //   }
  //   this.buttonImage = '../assets/images/spin_off.png';
  //   // document.getElementById('spin_button').className = '';
  //   this.theWheel.startAnimation(new TweenMax(new TimelineMax()));
  //   this.wheelSpinning = true;
  // }

  // resetWheel(): void {
  //   this.theWheel.stopAnimation(false);
  //   this.theWheel.rotationAngle = 0;
  //   this.theWheel.draw();
  //   // Remove all colours from the power level indicators.
  //   document.getElementById('pw1').className = '';
  //   document.getElementById('pw2').className = '';
  //   document.getElementById('pw3').className = '';
  //   this.wheelSpinning = false;
  // }

  // alertPrize(): void {
  //   this.winningSegment = this.theWheel.getIndicatedSegment().text;
  //   alert('You have won ' + this.theWheel.getIndicatedSegment().text);
  // }

  // getSegment(e): void {
  //   const clickedSegment = this.theWheel.getSegmentAt(e.clientX, e.clientY);

  // }

  // calculatePrize(): void {
  //   // This formula always makes the wheel stop somewhere inside prize 3 at least
  //   // 1 degree away from the start and end edges of the segment.
  //   const stopAt = (91 + Math.floor((Math.random() * 43)));
  //   // const stopAt = (25 + Math.floor((Math.random() * 78)));
  //   // Important thing is to set the stopAngle of the animation before stating the spin.
  //   this.theWheel.animation.stopAngle = stopAt;
  //   // May as well start the spin from here.
  //   this.startSpin();
  // }

  //----------------------------NEW DESIGN----------------------------------------------------

  ngOnInit(): void {
    this.get_lucky_draw_options();
  }

  ngOnDestroy(): void {
    document.body.className = '';
  }

  alertPrize(): void {
    // The the indicated segments from the 2 wheels.
    let winningInnerSegment = this.innerWheel.getIndicatedSegment();
    let winningOuterSegment = this.outerWheel.getIndicatedSegment();

    this.winId = winningInnerSegment.id;

    // Alert the combination of prizes won.
    // alert('You won ' + winningInnerSegment.text + ', ' + winningOuterSegment.text);

    let formData = new FormData();
    formData.append('luckyDrawOptionId', this.winId);
    formData.append('customerPhone', this.entered_phone_number);

    this.auth.save_lucky_draw(formData).subscribe((response: any) => {
      this.lucky_draws = response.body.lucky_draws;
      this.saved_lucky_draw = response.body.saved_lucky_draw;
      this.rewardList = response.body.lucky_draws.length;
      this.chancesLeft = this.chancesLeft - 1;
    }, (e) => {
      this.toastr.error(e.error.message);
    })

    Swal.fire({
      title: `You won ${winningInnerSegment.text}, ${winningOuterSegment.text}`,
      confirmButtonText: 'Claim Now',
      showCancelButton: true,
      cancelButtonText: 'Claim Later',
      allowOutsideClick: false,
      width: 600,
      padding: '3em',
      background: '#fff url(../../../../assets/images/trees.png)',
      backdrop: `
        rgba(0,0,123,0.4)
        url("../../../../assets/images/nyan-cat.gif")
        left top
        no-repeat
      `
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Please enter your email address',
          input: 'text',
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: 'Claim',
          showLoaderOnConfirm: true,
          preConfirm: (login) => {
            // return fetch(`//api.github.com/users/${login}`)
            //   .then(response => {
            //     if (!response.ok) {
            //       throw new Error(response.statusText)
            //     }
            //     return response.json()
            //   })
            //   .catch(error => {
            //     Swal.showValidationMessage(
            //       `Request failed: ${error}`
            //     )
            //   })

            if (login.trim().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) == null) {
              // return this.toastr.error('Please enter valid email.');
              Swal.showValidationMessage(
                `Please enter a valid email address.`
              )
            }

            return login;
          },
          // allowOutsideClick: () => !Swal.isLoading()
          allowOutsideClick: false
        }).then((result) => {
          if (result.isConfirmed) {
            // Swal.fire({
            //   title: `${result.value.login}'s avatar`,
            //   imageUrl: result.value.avatar_url
            // })

            let formData = new FormData();
            formData.append('luckyDrawId', this.saved_lucky_draw.id);
            formData.append('email', result.value);

            this.auth.claim_lucky_draw(formData).subscribe((response: any) => {
              this.lucky_draws = response.body;

              Swal.fire(
                'Done!',
                'Claimed successfully.',
                'success'
              )
            }, (e) => {
              this.toastr.error(e.error.message);
            })
          }
        })
      }
    })

    // Set things so power and spin button can be clicked again.
    this.wheelSpinning = false;

    // Remove all colours from the power level indicators.
    // document.getElementById('pw1').className = "";
    // document.getElementById('pw2').className = "";
    // document.getElementById('pw3').className = "";
  }

  drawInnerWheel(): void {
    // Update the rotationAngle of the innnerWheel to match that of the outer wheel - this is a big part of what
    // links them to appear as one 2-part wheel. Call the draw function passing false so the outer wheel is not wiped.
    this.innerWheel.rotationAngle = this.outerWheel.rotationAngle;
    this.innerWheel.draw(false);
  }

  startSpin() {
    // Ensure that spinning can't be clicked again while already running.
    if (this.wheelSpinning == false) {
      // Reset things with inner and outer wheel so spinning will work as expected. Without the reset the
      // wheel will probably just move a small amount since the rotationAngle would be close to the targetAngle
      // figured out by the animation.
      this.outerWheel.stopAnimation(false);  // Stop the animation, false as param so does not call callback function.
      this.outerWheel.rotationAngle = 0;     // Re-set the wheel angle to 0 degrees.
      this.outerWheel.draw();                // Call draw to render changes to the wheel.
      this.innerWheel.rotationAngle = 0;
      this.innerWheel.draw(false);

      // Based on the power level selected adjust the number of spins for the wheel, the more times is has
      // to rotate with the duration of the animation the quicker the wheel spins.
      if (this.wheelPower == 1) {
        this.outerWheel.animation.spins = 3;     // Number of spins and/or duration can be altered to make the wheel
        this.outerWheel.animation.duration = 7;  // appear to spin faster or slower.
      } else if (this.wheelPower == 2) {
        this.outerWheel.animation.spins = 8;
        this.outerWheel.animation.duration = 7;
      } else if (this.wheelPower == 3) {
        this.outerWheel.animation.spins = 15;
      }

      // Disable the spin button so can't click again while wheel is spinning.
      // document.getElementById('spin_button').src = "spin_off.png";
      // document.getElementById('spin_button').className = "";

      // Begin the spin animation by calling startAnimation on the wheel object.
      this.outerWheel.startAnimation();

      // Set to true so that power can't be changed and spin button re-enabled during
      // the current animation. The user will have to reset before spinning again.
      this.wheelSpinning = true;
    }
  }

  lucky_draw_check_if_phone_exists(event) {
    this.entered_phone_number = event.target.value.trim();

    if (this.entered_phone_number.length == 0) {
      this.hideShowLoader = 0;
      this.hideShowCheckMark = 0;
      this.chancesLeft = 0;
      this.rewardList = 0;
      this.lucky_draws = [];
      return
    }

    if (this.entered_phone_number.length > 7) {
      let formData = new FormData();
      formData.append('phone_number', this.entered_phone_number.trim());

      this.auth.lucky_draw_check_if_phone_exists(formData).subscribe((response: any) => {
        this.hideShowCheckMark = response.body.exists;
        this.chancesLeft = response.body.count;
        this.rewardList = response.body.lucky_draws.length;
        this.hideShowLoader = (response.body.exists == 1) ? 0 : 1;

        this.lucky_draws = response.body.lucky_draws;
      }, (e) => {
        this.toastr.error(e.error.message);
      })
    } else {
      this.hideShowLoader = 1;
      this.hideShowCheckMark = 0;
      this.chancesLeft = 0;
      this.rewardList = 0;
      this.lucky_draws = [];
    }
  }

  claim_lucky_draw(id) {
    Swal.fire({
      title: 'Please enter your email address',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: 'Claim',
      showLoaderOnConfirm: true,
      preConfirm: (login) => {
        // return fetch(`//api.github.com/users/${login}`)
        //   .then(response => {
        //     if (!response.ok) {
        //       throw new Error(response.statusText)
        //     }
        //     return response.json()
        //   })
        //   .catch(error => {
        //     Swal.showValidationMessage(
        //       `Request failed: ${error}`
        //     )
        //   })

        if (login.trim().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) == null) {
          // return this.toastr.error('Please enter valid email.');
          Swal.showValidationMessage(
            `Please enter a valid email address.`
          )
        }

        return login;
      },
      // allowOutsideClick: () => !Swal.isLoading()
      allowOutsideClick: false
    }).then((result) => {
      if (result.isConfirmed) {
        // Swal.fire({
        //   title: `${result.value.login}'s avatar`,
        //   imageUrl: result.value.avatar_url
        // })

        let formData = new FormData();
        formData.append('luckyDrawId', id);
        formData.append('email', result.value);

        this.auth.claim_lucky_draw(formData).subscribe((response: any) => {
          this.lucky_draws = response.body;

          Swal.fire(
            'Done!',
            'Claimed successfully.',
            'success'
          )
        }, (e) => {
          this.toastr.error(e.error.message);
        })
      }
    })

  }
}